import CardDiscipline from '../../../../../modules/Memory/components/card-discipline';
import BrainLoadingWrapper from '../../../molecules/BrainLoading';
import { Typography } from '../../../molecules/Typography';

interface Subject {
  title: string;
  _id: string;
}

interface LessonFlashcardsProps {
  flashcards: IFlashcardByVideoAulaResponse[];
  isLoading: boolean;
  subject?: Subject;
  onSuccessFallback: (uuid: string) => void;
  title?: string;
  emptyMessage?: string;
  gridClassName?: string;
}

export default function LessonFlashcards({
  flashcards,
  isLoading,
  subject,
  onSuccessFallback,
  title = 'FLASHCARDS',
  emptyMessage,
  gridClassName = 'grid grid-cols-1 gap-xxxl',
}: LessonFlashcardsProps) {
  if (isLoading) {
    return <BrainLoadingWrapper />;
  }

  if (flashcards.length === 0 && emptyMessage) {
    return (
      <div className='mb-8 mt-8 flex flex-col gap-sm'>
        <Typography
          type='titleSection'
          size='h5'
          className='text-mono-color-black'
        >
          {emptyMessage}
        </Typography>
      </div>
    );
  }

  if (flashcards.length === 0) {
    return null;
  }

  return (
    <div className='mb-8 mt-8 flex flex-col gap-sm'>
      <Typography
        type='titleSection'
        size='h5'
        className='text-mono-color-dark'
      >
        <i>{title}</i>
      </Typography>
      <div className={gridClassName}>
        {flashcards.map((flashcard) => (
          <CardDiscipline
            key={flashcard.uuid}
            front={flashcard.front}
            uuid={flashcard.uuid}
            tags={flashcard?.tags || []}
            discipline={flashcard?.discipline || undefined}
            hasVinculed={flashcard?.hasVinculed || false}
            shouldReview={flashcard?.shouldReview || false}
            onSuccessFallback={() => onSuccessFallback(flashcard.uuid)}
            subject={{
              id: subject?._id || '',
              name: subject?.title || '',
            }}
          />
        ))}
      </div>
    </div>
  );
}
